<template>
  <div class="w-full">
    <div
      class="relative z-[2] border-1 rounded-2xl min-w-full min-h-[110vh] md:min-h-[50vh] lg:min-h-[110vh] 2xl:min-h-[90vh] flex flex-col px-2 pt-[75px] laptop:pt-6 tablet:pt-5 pb-5 border-gray-300 bg-[#FFFFFF80]">
      <div
        class="mobile:left-0 mx-auto flex flex-col-reverse tablet:flex-row justify-between items-center gap-2.5 tablet:gap-2 absolute -top-6 right-0 tablet:left-auto w-full px-2.5 laptop:px-[15px]">
        <div
          class="w-full tablet:w-2/3 laptop:w-3/5 largeDesktop:w-1/2 flex flex-col-reverse tablet:flex-row gap-[10px] tablet:gap-[15px]">
          <div
            class="relative w-full desktop:w-4/5 largeDesktop:w-2/3 flex items-center justify-between !rounded-full 2xl:!rounded-full overflow-hidden border !border-customGray h-max pl-[2px] pr-[10px] bg-[#fff] shadow-[0px_0px_10px_0px_#00000026]">
            <span
              class="px-[20px] rounded-full font-poppins font-normal text-[14px] hidden laptop:flex items-center min-w-max h-[36px] text-[#fff] bg-[#F5B134]">Date
              Created</span>
            <div class="flex mobile:justify-between items-center w-full laptop:w-auto">
              <dateRangePicker ref="datePicker" v-model="selectedDate" :value="selectedDate" :disable-future="true"
                @change="onDateChange"
                input-class="!p-[10px] laptop:!px-[5px] 2xl:!px-0 2xl:!py-[0px] !text-[14px] !h-[40px] date-picker mx-input cursor-pointer  focus:outline-none laptop:w-[175px] largeDesktop:w-[173px] border-0" />
              <img src="../../assets/images/calendar-icon.svg" alt="Calendar Icon" @click="openDatePicker"
                @mousedown.stop class="w-[26px] h-[26px] object-contain cursor-pointer">
            </div>
          </div>
        </div>
        <div
          class="mobile:w-full right-0 mobile:left-0 laptop:w-4/5 desktop:w-3/5 largeDesktop:w-3/6 mx-auto flex tablet:justify-end items-center gap-2 tablet:left-auto">
          <entities :modelValue="limit" @update:modelValue="onLimitChange" globalEntitiesClass="'tablet:w-[45%]'" />
          <searchInput :globalSearchClass="'mobile:w-full tablet:!w-[55%]'"
            :input-class="'rounded-full shadow-[0px_0px_10px_0px_#00000026] pl-3 pr-16 py-3 w-full h-10 bg-white disabled:!bg-white disabled:opacity-100 focus:outline-none font-Poppins text-[14px] placeholder:text-[#999999]'"
            :buttonclass="'absolute top-1.5 right-1 w-7 h-7'" :img-src="require('@/assets/images/search-icon-01.png')"
            :clearClass="'absolute top-0 flex items-center justify-center !h-[100%] right-[2.2rem] laptop:w-4 laptop:h-4 largeDesktop:w-6 largeDesktop:h-6'"
            v-model="search" @input="onSearch" :onClear="onClearSearch" :readonly="loading" :clearable="true" />
        </div>
      </div>
      <div>
        <div class="block laptop:hidden">
          <div v-if="tableItems.length > 0" class="mt-2 min-h-[50vh]">
            <billingHistoryTansactionList v-for="(item, index) in tableItems" :key="index" :item="item"
              @update="onActionClicked" />
          </div>
          <div v-else>
            <h6
              class="flex justify-center items-center font-poppins text-[20px] laptop:text-[30px] min-h-[60vh] 2xl:min-h-[80vh] m-0 text-[#333333]"
              v-if="tableItems == null || (tableItems && tableItems.length == 0)">
              No Record Found
            </h6>
          </div>
        </div>
      </div>
      <div class="mt-2 laptop:block hidden">
        <billingHistoryTransactionTable :tableHeaders="tableHeaders" :tableData="tableItems" :sortClicked="sortClicked"
          @update="onActionClicked" />
      </div>
    </div>
    <div v-if="tableItems && tableItems.length > 0"
      class="flex mobile:flex-col tablet:flex-row mobile:gap-3 tablet:gap-0 items-center justify-between relative -top-5 px-3 z-10">
      <paginationEntries class="mobile:hidden tablet:block" :currentPage="page" :perPage="limit"
        :totalItems="totalItems" />
      <customPagination :page="page" :total_pages="total_pages" :updatePage="updatePage" />
    </div>
  </div>


  <!-- Contractor Modal Modal -->
  <div class="modal fade" id="contractorModal" ref="contractorModal" tabindex="-1" aria-labelledby="contractorModal"
    aria-hidden="true">
    <div
      class="modal-dialog modal-dialog-centered mobile:!w-full mobile:!right-0 mobile:!px-3 tablet:!w-[500px] !absolute tablet:!right-4 !top-0 !m-0 h-full">
      <div class="modal-content select-none">
        <div class="modal-body !p-2.5 !pb-5">
          <div
            class="relative w-full mobile:h-[70px] tablet:h-[80px] rounded-lg overflow-hidden flex items-center justify-start">
            <button type="button" class="absolute top-1.5 right-1.5 w-6 h-6 z-50 focus:!outline-none focus:!shadow-none"
              data-bs-dismiss="modal" aria-label="Close">
              <img src="../../assets/images/modal-cross-icon.svg" alt="Cross Icon"
                class="w-[30px] h-[30px] object-contain">
            </button>
            <div
              class="rounded-lg overflow-hidden h-[80px] bg-customBlue-100 flex flex-col justify-center gap-1 p-3 w-full">
              <h4 class="text-xl font-semibold font-poppins m-0 text-white">
                Details
              </h4>
            </div>
          </div>
          <div ref="scrollBox" class="max-h-[550px] overflow-y-auto customScrollbar mobile:mt-2 tablet:mt-6">
            <companyDetailDropdown :item="planDetails" />
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import { mapActions, mapGetters } from "vuex";
import entities from "../../components/showEntities/entities.vue";
import searchInput from '../../components/partialComponent/customInput.vue';
import billingHistoryTransactionTable from "./billingHistoryTransactionTable.vue";
import billingHistoryTansactionList from './billingHistoryTansactionList.vue';
// import createQoute from "../../components/createQuote/createQuote.vue";
import customPagination from "../../components/partialComponent/customPagination.vue";
import paginationEntries from "../../components/partialComponent/pagination-entries.vue";
import companyDetailDropdown from "../../components/companyDetailModal.vue";
import dateRangePicker from "../../components/partialComponent/DateRangePicker.vue";
import moment from "moment";

export default {
  components: {
    entities,
    searchInput,
    billingHistoryTransactionTable,
    // createQoute,
    customPagination,
    paginationEntries,
    companyDetailDropdown,
    billingHistoryTansactionList,
    dateRangePicker
  },
  data() {
    return {
      limit: 25,
      search: "",
      page: 1,
      total_pages: 0,
      totalItems: 0,
      debounceTimer: null,
      loading: false,
      tableHeaders: [],
      tableItems: [],
      selectedSort: {
        "column": "agreement_id",
        "direction": "DESC"
      },
      planDetails: null,
      selectedDate: this.getYearToDate(),
    }
  },
  computed: {
    ...mapGetters([
      "billingTransactionListing",
      "salesPlanDetails",
      "purchaseCancelValidateResponse",
      "purchasePlanCancelResponse"
    ]),
  },
  watch: {
    billingTransactionListing: function (data) {
      this.loading = false
      this.tableItems = this.billingTransactionListing.body
      this.total_pages = this.billingTransactionListing.paging.total_pages
      this.totalItems = this.billingTransactionListing.paging.total_records
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },

    purchaseCancelValidateResponse: function (data) {
      this.$dialog.show({
        title: "Cancel Plan",
        text: "html",
        html: (this.purchaseCancelValidateResponse.validation_passed == 1) ? "Are you sure you want to cancel?" : this.purchaseCancelValidateResponse.message,
        onConfirm: () => {
          this.purchasePlanCancel(this.purchaseCancelValidateResponse)
        },
      });
    },

    purchasePlanCancelResponse: function (data) {
      this.getTransactionListing({
        "search": this.search,
        "limit": this.limit,
        "page": this.page,
        'sort[column]': this.selectedSort.column,
        'sort[direction]': this.selectedSort.direction,
        'date_option': 'created-date',
        date_range: `${this.selectedDate[0]} - ${this.selectedDate[1]}`
      });
    },

    salesPlanDetails: function (data) {
      this.planDetails = this.salesPlanDetails
      const { Modal } = require('bootstrap');
      const modalEl = this.$refs.contractorModal;
      this.Modal = Modal.getInstance(modalEl);
      if (!this.Modal) {
        this.Modal = new Modal(modalEl, {
          backdrop: 'static',
          keyboard: false
        });
      }
      modalEl.addEventListener('show.bs.modal', () => {
        // document.documentElement.style.overflow = 'hidden'; // Target HTML element
        this.adjustPlanModalHeight();
        window.addEventListener('resize', this.adjustPlanModalHeight);
        window.addEventListener('orientationchange', this.adjustPlanModalHeight);
        if (window.innerWidth >= 992) {
          document.documentElement.style.paddingRight = '15px';
        } else {
          document.documentElement.style.paddingRight = '0px';
        }
      });
      modalEl.addEventListener('hidden.bs.modal', () => {
        window.addEventListener('resize', this.adjustPlanModalHeight);
        window.addEventListener('orientationchange', this.adjustPlanModalHeight);
        // document.documentElement.style.overflow = ''; // Reset HTML element
        document.documentElement.style.paddingRight = '0px';
      });
      this.Modal.show();
      setTimeout(() => {
        if (this.$refs.scrollBox) {
          this.$refs.scrollBox.scrollTo({ top: 0, behavior: "smooth" })
        }
      }, 200);
    },
  },
  mounted() {
    this.setTableHeaders();
    this.loading = true
    this.getTransactionListing({
      "search": this.search,
      "limit": this.limit,
      "page": this.page,
      'sort[column]': this.selectedSort.column,
      'sort[direction]': this.selectedSort.direction,
      'date_option': 'created-date',
      date_range: `${this.selectedDate[0]} - ${this.selectedDate[1]}`
    });
    const container = document.getElementById('scrollContainer');
    if (container) {
      container.addEventListener('scroll', this.hideDatePicker, true);
    } else {
      console.warn('scrollContainer not found by ID');
    }
  },
  beforeUnmount() {
    const container = document.getElementById('scrollContainer');
    if (container) {
      container.removeEventListener('scroll', this.hideDatePicker, true);
    }

  },
  methods: {
    ...mapActions([
      "getPurchasePlanDetails",
      "getTransactionListing",
      "getPurchaseCancelValidation",
      "purchasePlanCancel"
    ]),
    getYearToDate() {
      return [
        moment().startOf("year").format("MM/DD/YYYY"),
        moment().format("MM/DD/YYYY")
      ];
    },
    hideDatePicker() {
      if (this.$refs.datePicker) {
        // works for most custom date pickers
        this.$refs.datePicker.handleScroll?.();
        this.$refs.datePicker.blur?.();
      }
    },
    onDateChange(data) {
      this.page = 1
      this.selectedDate = data.dates,
        this.getTransactionListing({
          "search": this.search,
          "limit": this.limit,
          "page": this.page,
          'sort[column]': this.selectedSort.column,
          'sort[direction]': this.selectedSort.direction,
          'date_option': 'created-date',
          date_range: `${this.selectedDate[0]} - ${this.selectedDate[1]}`
        });
      // this.getCommissionsList(this.getRequestParams())
    },
    openDatePicker() {
      if (this.$refs.datePicker) {
        this.$refs.datePicker.openDatePicker();
      }
    },
    updatePage(page) {
      if (page == this.page) return
      this.page = page
      this.loading = true
      this.getTransactionListing({
        "search": this.search,
        "limit": this.limit,
        "page": this.page,
        'sort[column]': this.selectedSort.column,
        'sort[direction]': this.selectedSort.direction,
        'date_option': 'created-date',
        date_range: `${this.selectedDate[0]} - ${this.selectedDate[1]}`
      });
    },
    onActionClicked(data, option) {
      if (option == 'Detail') {
        this.getPurchasePlanDetails({
          id: data.id
        })
      } else if (option == 'Cancel') {
        this.getPurchaseCancelValidation({
          id: data.id
        })
      }

    },
    onSearch() {
      clearTimeout(this.debounceTimer);
      // Start new debounce timer

      this.page = 1
      this.debounceTimer = setTimeout(() => {
        if (this.search.length == 0 || this.search.trim().length > 0) {
          this.loading = true
          this.getTransactionListing({
            "search": this.search,
            "limit": this.limit,
            "page": this.page,
            'sort[column]': this.selectedSort.column,
            'sort[direction]': this.selectedSort.direction,
            'date_option': 'created-date',
            date_range: `${this.selectedDate[0]} - ${this.selectedDate[1]}`
          });
        }
      }, 1000); // 1200ms delay
    },
    onClearSearch() {
      clearTimeout(this.debounceTimer);
      this.page = 1
      this.search = ''
      this.loading = true
      this.getTransactionListing({
        "search": this.search,
        "limit": this.limit,
        "page": this.page,
        'sort[column]': this.selectedSort.column,
        'sort[direction]': this.selectedSort.direction,
        'date_option': 'created-date',
        date_range: `${this.selectedDate[0]} - ${this.selectedDate[1]}`
      });

    },
    adjustPlanModalHeight() {
      const modalContent = this.$refs.scrollBox;
      if (modalContent) {
        const vh = window.innerHeight;
        const vw = window.innerWidth;
        let maxHeight;
        if (vw < 300) {
          maxHeight = vh * 0.5 - 40;
        } else if (vw < 768) {
          maxHeight = vh * 0.8 - 50;
        } else if (vw < 991) {
          maxHeight = vh * 0.8 - 50;
        } else if (vw < 1440) {
          maxHeight = vh * 0.8 - 50;
        }
        else {
          maxHeight = vh * 0.8 - 40;
        }
        modalContent.style.maxHeight = `${maxHeight}px`;
        modalContent.style.overflowY = 'auto';
      }
    },
    onLimitChange(newLimit) {
      this.limit = newLimit;
      this.page = 1;
      this.loading = true;
      this.getTransactionListing({
        search: this.search,
        limit: this.limit,
        page: this.page,
        'sort[column]': this.selectedSort.column,
        'sort[direction]': this.selectedSort.direction,
        'date_option': 'created-date',
        date_range: `${this.selectedDate[0]} - ${this.selectedDate[1]}`
      });
    },
    setTableHeaders() {
      this.tableHeaders = [
        this.getTableHeaderObject("Invoice ID", "po_invoice_id", "po_invoice_id", "", "1"),
        this.getTableHeaderObject("Order Number", "order_number", "order_number", "", "1"),
        this.getTableHeaderObject("Service Address", "service_address", "service_address", "", "1"),
        this.getTableHeaderObject("Created Date", "created_at", "created_at", "", "1"),
        this.getTableHeaderObject("Paid Date", "paid_date", "paid_date", "", "1"),
        this.getTableHeaderObject("Amount", "invoice_amount", "invoice_amount", "", "1"),
        this.getTableHeaderObject("Status", "action_status", "paid_status", "", "1"),
        this.getTableHeaderObject("Payment Type", "payment_type", "payment_type", "", "0"),
      ]
      this.setSort()
    },
    getTableHeaderObject(title, data_value, sort_column, sort_direction, sort_applicable, isHeaderToolTipShow = 0, tooltip_text = '') {
      return {
        title: title,
        data_value: data_value,
        sort_column: sort_column,
        sort_direction: sort_direction,
        sort_applicable: sort_applicable,
        isHeaderToolTipShow: isHeaderToolTipShow,
        tooltip_text: tooltip_text
      }
    },
    setSort() {
      this.tableHeaders.map(obj => {
        if (obj.sort_column == this.selectedSort.column) {
          obj.sort_direction = this.selectedSort.direction;
        } else {
          obj.sort_direction = "";
        }
      });
    },
    sortClicked(item) {
      if (item.sort_applicable == '1') {
        this.page = 1
        if (item.sort_column == this.selectedSort.column) {
          this.selectedSort.direction = item.sort_direction == "DESC" ? "ASC" : "DESC"
          item.sort_direction = this.selectedSort.direction
        } else {
          this.tableHeaders.map(obj => {
            obj.sort_direction = "";
          });
          this.selectedSort.column = item.sort_column
          this.selectedSort.direction = item.sort_direction == "DESC" ? "ASC" : "DESC"
          item.sort_direction = this.selectedSort.direction
        }
        this.getTransactionListing({
          search: this.search,
          limit: this.limit,
          page: this.page,
          'sort[column]': this.selectedSort.column,
          'sort[direction]': this.selectedSort.direction,
          'date_option': 'created-date',
          date_range: `${this.selectedDate[0]} - ${this.selectedDate[1]}`
        })
      }
    },
  },
};
</script>
